<template>
  <div class="dp_flex">
    <div class="box1">
      <template v-if="imgSrc">
        <img
          :src="imgSrc"
          style="cursor: pointer;"
          @click="onClickThumbnail"
        >
      </template>
      <template v-else>
        <a
          v-if="utilsTrim(fileUid) !==''"
          class="noimg"
          style="cursor: pointer;"
          @click="onClickNoThumbnail"
        >
          {{ noThumbnailText }}
        </a>
        <span v-else>
          {{ noFileUidText }}
        </span>
      </template>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CellThumbnail',
  props: {
    // 컴포넌트를 사용하는 페이지ID
    pageId: {
      type: String,
      required: true,
    },
    noThumbnailText: {
      type: String,
      required: false,
      default() {
        return '';
        // return utils.getMessageById('MSG_TXT_NO_THUMBNAIL');
      },
    },
  },
  data() {
    return {
      fileUid: '',
      imgSrc: null,
      noFileUidText: '',
    };
  },
  methods: {
    utilsTrim(value) {
      return utils.trim(value);
    },
    /**
     * 썸네일 click event handler
     * real size 이미지를 다운받아서 사진보기 팝업을 띄우면서 초기값으로 담아준다.
     * @function onClickThumbnail
     * @param {None}
     * @returns {None}
     */
    onClickThumbnail() {
      this.downloadImage().then(file => {
        utils.openLayerPopup('PGE_CMZ_00014', () => {
        }, {
          pageInitialData: { file },
          size: 'lg',
        });
      });
    },
    onClickNoThumbnail() {
      this.downloadImage().then(file => {
        utils.openLayerPopup('PGE_CMZ_00014', () => {
        }, {
          pageInitialData: { file },
          size: 'lg',
        });
      });
    },
    setValue(imgSrc, fileUid) {
      this.imgSrc = imgSrc;
      this.fileUid = fileUid;
    },
    /**
     * @function downloadImage
     * @param {None}
     * @returns {Promise}
     */
    downloadImage() {
      return new Promise((resolve, reject) => {
        http.request(this.pageId, 'DTS_CMZ_00068', {
          path: {
            'target-path': 'storage',
          },
          query: {
            fileUid: this.fileUid,
          },
          responseType: 'arraybuffer',
        }).then(res => {
          const blob = new Blob([res.data], { type: res.headers['content-type'] });
          resolve(blob);
        }).catch(err => {
          reject(err);
        });
      });
    },
  },
};
</script>

<style scoped>
</style>
